import { render, staticRenderFns } from "./ModalVerHistorial.vue?vue&type=template&id=4e1165c2&"
import script from "./ModalVerHistorial.vue?vue&type=script&lang=ts&"
export * from "./ModalVerHistorial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4e1165c2', component.options)
    } else {
      api.reload('4e1165c2', component.options)
    }
    module.hot.accept("./ModalVerHistorial.vue?vue&type=template&id=4e1165c2&", function () {
      api.rerender('4e1165c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MotivodeBaja/ModalVerHistorial.vue"
export default component.exports